"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncReportDimensionToJSON = exports.AsyncReportDimensionFromJSONTyped = exports.AsyncReportDimensionFromJSON = exports.AsyncReportDimension = void 0;
/**
 *
 * @export
 */
exports.AsyncReportDimension = {
    AdAccountName: 'AD_ACCOUNT_NAME',
    AdAccountCurrency: 'AD_ACCOUNT_CURRENCY',
    CampaignName: 'CAMPAIGN_NAME',
    CampaignStatus: 'CAMPAIGN_STATUS',
    CampaignObjective: 'CAMPAIGN_OBJECTIVE',
    AdSetName: 'AD_SET_NAME',
    AdSetStatus: 'AD_SET_STATUS',
    AdSetBudget: 'AD_SET_BUDGET',
    AdSetCostModel: 'AD_SET_COST_MODEL',
    AdName: 'AD_NAME'
};
function AsyncReportDimensionFromJSON(json) {
    return AsyncReportDimensionFromJSONTyped(json, false);
}
exports.AsyncReportDimensionFromJSON = AsyncReportDimensionFromJSON;
function AsyncReportDimensionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AsyncReportDimensionFromJSONTyped = AsyncReportDimensionFromJSONTyped;
function AsyncReportDimensionToJSON(value) {
    return value;
}
exports.AsyncReportDimensionToJSON = AsyncReportDimensionToJSON;
